import styled from '@emotion/styled'

import { BuildIcon, ReportIcon, EmbedIcon } from '@segment/matcha/components/Icons/Brandbook'
import Tabs, { useTabs } from '@segment/matcha/components/Tabs'

import CarouselCardBase, * as CarouselCard from '@segment/matcha/recipes/CarouselCard'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionTabbedBase, * as SectionTabbed from '@segment/matcha/recipes/SectionTabbed'

import BuildImage from './BuildImage'
import EmbedImage from './EmbedImage'
import DocumentImage from './DocumentImage'

const copy = {
  heading: `Build an integration within hours`,
  description: `Building a Segment integration is fast and straightforward. With the Developer Portal you can test, submit, and maintain your Segment integration and OAuth flow.`,
}

const tabs = [
  {
    key: `build`,
    title: `Build`,
    description: `Building a Segment endpoint is easy with comprehensive docs, tooling, and access to support.`,
    icon: <BuildIcon />,
    image: <BuildImage />,
  },
  {
    key: `embed`,
    title: `Embed`,
    description: `Increase conversion by an average of 2x when you embed the "Enable with Segment" button in your app to streamline onboarding and POCs.`,
    icon: <EmbedIcon />,
    image: <EmbedImage />,
  },
  {
    key: `document`,
    title: `Document`,
    description: `Publish public-facing docs on your website and submit them alongside your Segment integration.`,
    icon: <ReportIcon />,
    image: <DocumentImage />,
  },
]

const BuildIntegration = () => {
  const { activeTabKey, getTabsProps, getTabsMotionProps } = useTabs(tabs[0].key)

  return (
    <SectionComponent variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <SectionTabbedBase>
          <SectionTabbed.Copy>
            <Tabs {...getTabsProps()} mode="vertical" variant="filled">
              {tabs.map((tab) => (
                <CarouselCardBase value={tab.key} key={tab.key} active={tab.key === activeTabKey}>
                  <CarouselCard.Container alignment="left" headerPosition="top">
                    <CarouselCard.Header>{tab.icon}</CarouselCard.Header>
                    <CarouselCard.Body>
                      <CarouselCard.Title>{tab.title}</CarouselCard.Title>
                      <CarouselCard.Text>{tab.description}</CarouselCard.Text>
                    </CarouselCard.Body>
                  </CarouselCard.Container>
                </CarouselCardBase>
              ))}
            </Tabs>
          </SectionTabbed.Copy>
          {tabs.map((tab) => (
            <SectionTabbed.Media key={tab.key} {...getTabsMotionProps(tab.key)}>
              <SectionTabbed.Picture>{tab.image}</SectionTabbed.Picture>
            </SectionTabbed.Media>
          ))}
        </SectionTabbedBase>
      </Section.Contents>
    </SectionComponent>
  )
}

export default BuildIntegration

const SectionComponent = styled(SectionBase)`
  overflow: hidden;
`
